export default __webpack_public_path__ + "static/media/banner2.9b710bb5.png";